export enum ServiceSharing {
    PVT = 'PVT',
    SHARED = 'SHARED'
}
